import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { GRECIA_ANDREINA_ANCHOR_SRC } from '../brandAssets';

const ANCHOR_IMAGE = GRECIA_ANDREINA_ANCHOR_SRC;

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          En Sintonía con tu Salud: bienestar integral y prevención
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          ¿Es posible alcanzar el bienestar integral en un mundo que no se detiene? Un espacio donde la ciencia y la cotidianidad se encuentran con claridad y calidez.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es En Sintonía con tu Salud?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/ensintoniacontusalud"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/ensintoniacontusalud
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Programa de salud y bienestar con la <strong>Dra. Grecia Andreina</strong>: entrevistas con especialistas, orientación preventiva y hábitos para una vida plena. En vivo, On-Demand y TNO Digest en TNO Network.
        </Typography>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src={ANCHOR_IMAGE}
                alt="Dra. Grecia Andreina - En Sintonía con tu Salud"
                sx={{
                  width: { xs: 200, sm: 250, md: 300 },
                  height: { xs: 200, sm: 250, md: 300 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  boxShadow: 3,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              NUESTRA ANCLA: DRA. GRECIA ANDREINA
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              Médica y comunicadora · bienestar integral, prevención y salud con evidencia
            </Typography>
            <Typography variant={'body1'} color={'textSecondary'}>
              La <strong>Dra. Grecia Andreina</strong> conduce <strong>En Sintonía con tu Salud</strong> en TNO Network: más que un programa médico, un encuentro semanal donde la audiencia encuentra herramientas accionables para cuidar cuerpo y mente. Ideal para clínicas, laboratorios, marcas de wellness, nutrición y servicios de salud preventiva.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
